import React from "react";
import { spinner } from "../assets";

export default function Loading() {
  return (
    <div className="spinner_container">
      <div className="column-center">
        <img src={spinner} alt="spinner" className="spinner_img" />
        <p>Loading...</p>
      </div>
    </div>
  );
}
